import { Controller } from "@hotwired/stimulus";
import { useIntersection, useTransition } from 'stimulus-use'

export default class extends Controller {
    static targets = [
        'video'
    ]

    static values = {
        active: Boolean
    }

    created = false

    connect() {
        this.video.load();

        useTransition(this, {
            element: this.video,
            enterActive: "transition-opacity ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leaveActive: "transition-opacity ease-in duration-300",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            hiddenClass: '',
            transitioned: this.activeValue
        })

        if (this.activeValue) {
            this.video.currentTime = 0
            this.video.play()
        }

        this.created = true
    }

    activeValueChanged() {
        this.element.classList.toggle('hidden', this.activeValue === false)

        if (this.created) {
            try {
                if (this.activeValue) {
                    this.enter()
                    this.video.currentTime = 0
                    this.video.play()
                } else {
                    this.video.pause()
                    this.leave()
                }
            } catch (error) {
                
            }
        }
    }

    appear() {
        try {
            this.pause()
        } catch (error) {
            
        }
    }

    disappear() {
        try {
            this.play()
        } catch (error) {
            
        }
    }

    wait (timeout = 0) {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve(), timeout);
        }) 
    }

    /**
     * @returns {HTMLVideoElement}
     */
    get video () {
        return this.videoTarget
    }
    
    get playing() {
        const video = this.video

        return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
    }
}
